import styled from 'styled-components'

import breakpoints from '../../constants/ui/breakpoints'

import { Section } from '../PageLayout'

export const AutomationOptionsStyled = styled(Section)`
  .content-box {
    background-color: ${({ theme }) => theme.backgroundPrimary};
    border-radius: 1.25rem;
    box-shadow: ${({ theme }) => theme.boxShadowPrimary};
    width: 100%;
    padding: 4rem 3rem 6rem;
    margin: 0 auto;

    @media (max-width: ${breakpoints.screenMD}) {
      max-width: 100%;
      width: 100%;
    }

    @media (max-width: ${breakpoints.screenSM}) {
      padding: 2.5rem 1.5rem;
    }
  }

  .title {
    max-width: 750px;
    margin-bottom: 3rem;

    @media (max-width: ${breakpoints.screenSM}) {
      max-width: 100%;
      margin-bottom: 1.5rem;
    }
  }

  .btn-group {
    display: flex;
    justify-content: space-between;
    gap: 2rem;
    min-width: 740px;
    margin-bottom: 3rem;

    @media (max-width: ${breakpoints.screenMD}) {
      gap: 1rem;
      min-width: 580px;

      button {
        min-width: fit-content;
      }
    }

    @media (max-width: ${breakpoints.screenSM}) {
      flex-direction: column;
      min-width: 90%;

      button {
        width: 100%;
      }
    }
  }

  .options-group {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    width: 100%;

    @media (max-width: ${breakpoints.screenSM}) {
      grid-template-columns: 1fr;
      gap: 3rem;
    }
  }

  .options {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;

    &:first-child {
      border-right: 1px solid ${({ theme }) => theme.borderSecondary};
      padding-right: 2rem;

      @media (max-width: ${breakpoints.screenSM}) {
        border-right: 0;
        padding-right: 0;
      }
    }

    &:last-child {
      padding-left: 2rem;

      @media (max-width: ${breakpoints.screenSM}) {
        padding-left: 0;
      }
    }
  }

  .items {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2.5rem 1rem;
    height: 100%;

    @media (max-width: ${breakpoints.screenSM}) {
      grid-template-columns: repeat(2, 1fr);
      justify-content: space-between;
      width: 100%;
      padding: 0;
    }
  }

  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    text-align: center;

    @media (max-width: ${breakpoints.screenSM}) {
      p {
        max-width: 140px;
      }
    }
  }

  .item-icon {
    max-width: 40px;
    height: 40px;
  }
`
